<template>
  <div>
    <work-area></work-area>
  </div>
</template>

<script>
import workArea from "../components/workArea";
export default {
  components: {
    workArea
  }

}
</script>

<style>
</style>